// extracted by mini-css-extract-plugin
export var md = "_2f-4";
export var semantic = "_2f-5";
export var sm = "_2f-3";
export var text = "_2f-6";
export var toggleInput = "_2f-0";
export var toggleSwitch = "_2f-1";
export var xs = "_2f-2";